import React from 'react'
import { Box, Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { makeStyles } from 'tss-react/mui'
import { StorageInstallationStatementKeys } from 'src/Libs/installation-statement/models/storage'
import Checkbox from 'src/Libs/inputs/formik/Checkbox'
import { useField } from 'formik'

const useStyles = makeStyles()(theme => ({
  container: {
    backgroundColor: theme.palette.shades.shade04,
    borderRadius: `${theme.shape.borderRadius}px`,
    padding: theme.spacing(4),
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(4),
    width: '100%',
  },
}))

/**
 * Component for toggling the display of the Edison step
 */
const EdisonWallBoxToggle: React.VFC = () => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  const [field] = useField(StorageInstallationStatementKeys.hasBiDiWallbox)

  return (
    <Box className={classes.container}>
      <Typography variant="h4" sx={{ pb: 2 }}>
        {t('installation-statement.edison.toggle.title')}*
      </Typography>
      <Typography variant="body2" sx={{ pb: 2 }}>
        {field.value ? t('installation-statement.edison.toggle.bidi-found') : t('installation-statement.edison.toggle.question')}
      </Typography>
      <Checkbox
        name={StorageInstallationStatementKeys.showEdisonWallboxStep}
        label={t('installation-statement.edison.toggle.checkbox')}
        disabled={field.value}
      />
    </Box>
  )
}

export default EdisonWallBoxToggle
